import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findVideosList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-home/v1/video?` + params,
        method: 'GET'
    })
}
export const findVideosListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-home/v1/video/downloadExcel?` + params,
        method: 'GET'
    })
}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}
export const findGoodslist = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sell/select?` + params,
        method: 'GET'
    })
}
export const findCouponlist = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon`,
        method: 'GET'
    })
}
export const downloadVideo = (id) => {
    return request({
        url: `${baseUrl}/joins-home/v1/video/download/${id}`,
        method: 'GET'
    })
}

export const addVideo = (data) => {
    return request({
        url: `${baseUrl}/joins-home/v1/video`,
        method: 'POST',
        data: data
    })
}
export const editVideo = (data) => {
    return request({
        url: `${baseUrl}/joins-home/v1/video`,
        method: 'PUT',
        data: data
    })
}
export const isShowVideo = (ids, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-home/v1/video/displayOrHide/${ids}?` + params,
        method: 'PUT',
    })
}
export const delVideo = (ids) => {
    return request({
        url: `${baseUrl}/joins-home/v1/video/${ids}`,
        method: 'DELETE',
    })
}


export const getAliyunVideoId = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-oss/v1/aliyun-vod/aliyunVod?` + params,
        method: 'GET'
    })
}
export const checkVideoLength = (data) => {
    return request({
        url: `${baseUrl}/joins-oss/v1/aliyun-vod/validVideoLength`,
        method: 'POST',
        data: data
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}